/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import { useEffect, useState } from 'react';
import { Modal } from '@material-ui/core';
import styles from '../pitch-quality-comment-modal/notification-modal.module.css';
import  DisconnectionIcon  from "../../public/icons/disconnection.svg";

const SubscriptionExhaustedModal = ({ onClose, open }) => {
  const handleClose = () => {
    localStorage.setItem('subscription_exhausted_modal_ignore', 'true');
    onClose();
  };

  useEffect(() => {
    const shouldShowModal = localStorage.getItem('subscription_exhausted_modal_ignore') !== 'true';
    if (!shouldShowModal) {
      handleClose();
    }
  }, []);

  return (
    <Modal
      className={styles['modal']}
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
    >
      <div className={styles['inner-container']} >
        <div className={styles['dialog-content']}>
            <div className="flex flex-col items-center justify-center w-full max-w-lg ">
            <div className="flex items-center mb-4">
              <div className="full flex items-center justify-center">
                    <DisconnectionIcon />
              </div>
            </div>
              <h2 className="text-xl font-semibold mb-2 font-manrope text-center whitespace-nowrap overflow-hidden text-ellipsis">
                 Monthly subscription exhausted
              </h2>
              <div className="w-full max-w-md">
                <p className="text-sm lg:text-base font-light mb-4 font-manrope text-center text-primary-dark leading-normal">
                 Your call analysis has stopped syncing as your monthly subscription is exhausted. Talk to us to upgrade and continue.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row justify-between sm:justify-center items-center w-full max-w-sm space-y-2 sm:space-y-0 sm:space-x-2 mt-2">
                <button
                  type="button"
                  className="w-full sm:w-42 px-4 py-2 h-[40px] rounded-md bg-secondary-light text-secondary sm:mr-2 text-[#31667F] text-sm"
                  onClick={handleClose}
                >
                  Do it Later
                </button>
              <a
                href="https://zipme.at/zipteams"
                target="_blank"
                rel="noreferrer"
                className="w-full sm:w-42 px-4 py-2 h-[40px] rounded-md bg-secondary text-background-white text-sm flex justify-center items-center"
              >
                Talk to us
              </a>
              </div>
            </div>
        </div>
      </div>
    </Modal>
  );
};

export default SubscriptionExhaustedModal;

